export enum DrawerAdminEvent {
    Edit = 'Edit Event',
    Create = 'Create Event',
}
export interface IAdminEvent {
    id: number;
    title: string;
    description: string;
    location: string;
    img: string | null ;
    date:string;
    time:string;
    createdAt: string;
    updatedAt: string;
    deletedAt: null | string;
}
export interface IAdminEventDto {
    title: string;
    description: string;
    location: string;
    date:string;
    time:string;
    img: string | null |File;
}